import { EnrichedNotificationNetwork } from '../models/enriched-notification-network.model';

export function mergeNotificationsByTokenId(
	items: EnrichedNotificationNetwork[],
): {
	tokenId: string;
	items: EnrichedNotificationNetwork[];
}[] {
	const groups = items.reduce((acc, item) => {
		const tokenId = item.tokenId;
		if (tokenId in acc) {
			acc[tokenId].items.push(item);
		} else {
			acc[tokenId] = {
				tokenId,
				items: [item],
			};
		}
		return acc;
	}, {});
	return Object.values(groups);
}
